module.exports = "/packs/media/images/olderlady_camping-9394ab371d8bf0c01bfd68c2d399d33c.jpg";